<template>
  <div class="my-5">
    <h2 class="section-heading mb-5">Before you go</h2>
    <b-form>
      <b-container id="ethnic-container">
        <Ethnic
          :noEthnic="noEthnic"
          :belfastCommunityError="belfastCommunityError"
          :belfastSexError="belfastSexError"
        />
        <br />
        <b-button variant="success" class="my-3" @click="submitEthnicity"
          >Submit</b-button
        >
      </b-container>
    </b-form>
  </div>
</template>

<script>
import Ethnic from "../components/application/Ethnic.vue";
import { mapGetters } from "vuex";
import { saveEthnicity } from "../services/api";

export default {
  components: {
    Ethnic,
  },
  data() {
    return {
      noEthnic: false,
      belfastCommunityError: false,
      belfastSexError: false,
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  },
  computed: {
    ...mapGetters({
      getToken: "authStore/getToken",
      getRecruit: "authStore/getRecruit",
    }),
  },
  methods: {
    async submitEthnicity() {
      this.noEthnic = false;
      const token = this.getToken;
      const {
        ethnic,
        belfastSelected,
        belfastsex,
        belfastcommunity,
      } = this.getRecruit;
      this.belfastCommunityError = false;
      this.belfastSexError = false;

      if (!ethnic) {
        this.noEthnic = true;
        document.getElementById("ethnic-container").scrollIntoView();
        return;
      }

      let belfastErr = false;
      if (belfastSelected) {
        if (!belfastsex) {
          belfastErr = true;
          this.belfastSexError = true;
        }

        if (!belfastcommunity) {
          belfastErr = true;
          this.belfastCommunityError = true;
        }

        if (belfastErr) {
          document.getElementById("belfast-questions").scrollIntoView();
          return;
        }
      }

      const data = { ethnic };
      if (belfastSelected) {
        data.belfastsex = belfastsex;
        data.belfastcommunity = belfastcommunity;
      }
      const res = await saveEthnicity(token, data);
      if (res.status === 200) {
        this.$router.push("/application/submit-success");
      }
    },
  },
};
</script>

<style scoped>
#ethnic-container {
  background-color: white;
}
</style>
